import { render, staticRenderFns } from "./DocumentViewerDialog.vue?vue&type=template&id=19de0df1&scoped=true"
import script from "./DocumentViewerDialog.vue?vue&type=script&lang=js"
export * from "./DocumentViewerDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewerDialog.vue?vue&type=style&index=0&id=19de0df1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de0df1",
  null
  
)

export default component.exports